import { render, staticRenderFns } from "./ComplianceQuestions.vue?vue&type=template&id=6b7382f8&scoped=true&"
import script from "./ComplianceQuestions.vue?vue&type=script&lang=js&"
export * from "./ComplianceQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7382f8",
  null
  
)

export default component.exports